import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Est-ce vraiment pour les débutants ?',
  a: 'Oui, nous partons de zéro pour arriver aux protocoles d\'élite.'
}, {
  q: "Ai-je besoin d'une salle de sport ?",
  a: 'Non, le Bonus n°2 couvre la rééducation à domicile sans matériel.'
}, {
  q: 'Est-ce un paiement unique ?',
  a: 'Oui. Payez une fois, accédez à vie aux 6 volumes et 5 bonus.'
}, {
  q: 'Comment accéder au matériel ?',
  a: "Vous recevez un lien de téléchargement immédiat par email après l'achat."
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Questions fréquemment posées" className="bg-transparent" data-id="element-39" data-mp="1v580xcj7l0v9">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-40" data-mp="oow1770qnaxk">
        <h2 className="text-center font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-41" data-mp="jq2o3fpd5lxx">
          ❓ Questions Fréquemment Posées
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-42" data-mp="1kp1iz7v7g7os">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-43" data-mp="1aoiwe5c9ad36" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-44" data-mp="1apanp3ytlonn">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-45" data-mp="16pa1gx5hc961">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-46" data-mp="s0w0krrmius4" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-47" data-mp="wxmg9dzinod0" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-48" data-mp="ixuwewmbjdr3">
                  <div className="overflow-hidden" data-id="element-49" data-mp="n1sur53tkkj3">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-50" data-mp="2pnopmsre5wv2">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}